import nodemailer from "nodemailer";
import "dotenv";
const SMTP_HOST = "smtp.zeptomail.in";
const SMTP_USER = "emailapikey";
const SMTP_PASSWORD = "Zoho-enczapikey PHtE6r0NRuDo2WUn9RVT5qW5EMDxN9l8r7w0KQURsd1ED/cCTE0HrNEpmjTl+UooB/VBFveTnNlusezN4riHIjvqZmwYWmqyqK3sx/VYSPOZsbq6x00fuFsffk3UU4Hud9Jq0CPQuNjaNA==";
const SMTP_FROM = "noreply@worldotutor.com";
async function sendmail(email, subject) {
  try {
    const transport = nodemailer.createTransport({
      host: SMTP_HOST,
      port: 587,
      auth: {
        user: SMTP_USER,
        pass: SMTP_PASSWORD
      }
    });
    let html = `
  <div style="font-family: Arial, sans-serif; padding: 2em; color: #222;">
    <h2 style="color: #ff7f2a;">Thank you for subscribing!</h2>
    <p>
      Hi${email ? `, <strong>${email}</strong>` : ""}!
    </p>
    <p>
      We're excited to have you as a part of our community. You'll be the first to know about new workshops, special offers, and updates.
    </p>
    <p>
      If you did not request this subscription, you can ignore this email.
    </p>
    <hr />
    <small style="color: #999;">Sent by ${SMTP_FROM || "Worldotutor Workshop"}</small>
  </div>
`;
    const mailer = {
      from: `"Worldotutor" <${SMTP_FROM}>`,
      to: email,
      subject,
      html
    };
    const info = await transport.sendMail(mailer);
    console.log(info);
    return info;
  } catch (error) {
    return JSON.stringify({
      message: `Internal error ${error}`
    });
  }
}
const actions = {
  default: async ({ request }) => {
    try {
      const data = await request.json();
      const { email } = data;
      const subject = "Thank you for subscribing to World'O'Tutors!";
      const resp = await sendmail(email, subject);
      console.log(resp);
      return resp.response;
    } catch (error) {
      console.log(error);
      return error;
    }
  }
};
export {
  actions
};
